import { Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const PHONE = "tel:+41766388655";
const WHATSAPP = "https://wa.me/41766388655?text=Bonjour%2C%20je%20souhaite%20un%20devis.";

const HeroSection = () => (
  <section className="relative min-h-[88vh] flex items-center overflow-hidden" aria-label="Accueil - ProImpact Carrosserie Genève">
    {/* Background image */}
    <div className="absolute inset-0">
      <img src="/hero-bg.webp" alt="Atelier ProImpact Carrosserie" className="w-full h-full object-cover" loading="eager" width={1400} height={788} fetchPriority="high" />
      <div className="absolute inset-0 z-[2] bg-gradient-to-r from-background via-background/85 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-40 z-[2] bg-gradient-to-t from-background to-transparent" />
    </div>

    <div className="container mx-auto relative z-10 px-4 pt-28 pb-16">
      <div className="max-w-2xl">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight mb-6">
          Votre carrossier
          <br />
          à Genève
        </h1>

        <p className="text-lg sm:text-xl text-muted-foreground max-w-lg mb-8 leading-relaxed">
          Tôlerie, peinture, débosselage sans peinture et jantes, toutes marques. Après un sinistre, nous gérons le
          dossier avec votre assurance : vous ne payez que la franchise.
        </p>

        <div className="flex flex-col sm:flex-row gap-3" data-cta-zone>
          <Button size="lg" className="h-14 px-7 gap-3 text-base font-semibold" asChild>
            <a href={PHONE}>
              <Phone className="w-5 h-5" /> +41 76 638 86 55
            </a>
          </Button>
          <Button size="lg" variant="outline" className="h-14 px-7 gap-3 text-base font-semibold bg-transparent" asChild>
            <a href={WHATSAPP} target="_blank" rel="noopener noreferrer">
              <MessageCircle className="w-5 h-5" /> WhatsApp
            </a>
          </Button>
        </div>

        <p className="mt-8 text-sm text-muted-foreground">
          Rue Voltaire 22, 1201 Genève · Devis gratuit sous 24 h · Véhicule de courtoisie dès CHF 49.–/jour
        </p>
      </div>
    </div>
  </section>
);

export default HeroSection;
